export const getIsAuthed = (state) => !!state.currentUser;
